export const checkAndRemoveCyclesCache = (isExtendedCapitation: boolean, resellerId: string) => {
  if (!isExtendedCapitation) {
    localStorage.removeItem(`choose-extended-cycle-${resellerId}`);
    localStorage.removeItem(`choose-new-cycle-${resellerId}`);
  }
};
